export enum PlanType {
	FREE = 'free',
	BASIC = 'basic',
	GOLD = 'gold',
	COMPANY_CLIENT = 'company_client'
}

export enum SubscriptionType {
    GOLD = "gold",
    GOLDLOAN = "gold_loan"
}

export enum Vendor {
	ELLIECARE = 'Ellie Care',
	MATERDEI = 'Mater Dei',
}

export interface PlanDescription {
    id: string,
    details: string,
    watch_price: number,
    plan_price: string,
    setup_price: string,
    devices: string[],
    functions: string[],
    quantity_companions: number,
    benefits: string[],
    mind: string[],
    permanence_time: string,
    created_at: Date,
    updated_at: Date
    delete_at: Date | null
}

export interface IPlan {
    id: string,
    plan_id: string,
    name: string,
    vendor: Vendor,
    plan_type: PlanType,
    subscription_type: SubscriptionType,
    user_template_email: string,
    vendor_email: string,
    vendor_template_email: string,
    plans_description: Partial<PlanDescription>,
    enabled: boolean,
    created_at: Date,
    updated_at: Date
    delete_at: Date | null,
}
